import { Box } from "@mui/material";

const BoxIcon = ({ height = 24, width = 24, color = "#657482", sx = {} }) => {
  return (
    <Box sx={sx}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.6667 6.25109L12.8236 1.27686C12.5192 1.10563 12.1475 1.10563 11.8431 1.27686L3 6.25109M21.6667 6.25109V16.1662C21.6667 16.5275 21.4718 16.8607 21.1569 17.0378L12.3333 22.0011M21.6667 6.25109L12.3333 11.5011M12.3333 22.0011L3.50974 17.0378C3.19486 16.8607 3 16.5275 3 16.1662V6.25109M12.3333 22.0011V11.5011M3 6.25109L12.3333 11.5011M17 3.62609L7.66667 8.87609"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export default BoxIcon;
